import React, {useState} from "react";
import { motion } from "framer-motion";
//25 Nov 2025
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";

const EtClientsHero = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Refined - 17 Oct 2025 - Unified message blend (Reflective + Strategic + Transformative)
  // Updated - 25 Nov 2025 - Refined for Unified CTA - ctaSource

  // 1 -  Local UI state 
  const [open, setOpen] = useState({ visible: false, source: null }); // 25 Nov 2025 - unified CTA


  return (
    <section
      id="clients-hero"
      className="h-screen flex items-center justify-center relative bg-gradient-to-br from-gray-900 via-black to-orange-900 text-white"
    >
      {/* Overlay texture */}
      <div className="absolute inset-0 opacity-15 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

      {/* Content */}
      <motion.div
        className="text-center z-10 px-4 max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* Headline */}
        <motion.h1
          className="text-4xl md:text-6xl font-bold mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {/* Building Growth Engines for Tech Services & Investment Leaders */}
          {/* Rethink Growth. Realign Energy. Redefine <span className="text-orange-500 animate-pulse">Performance</span>. */}
         
          Powering Up the <span className="text-orange-500 animate-pulse">Leaders</span> Who Power Growth.
         
        </motion.h1>

        {/* Subtext */}
        <motion.p
          className="text-lg md:text-xl text-gray-300 mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          {/* Whether you’re driving transformation across a portfolio or scaling a
          tech services firm, Eternity helps you turn strategic intent into
          measurable growth. */}
         
          {/* From founders to investors, Eternity partners with you to clarify vision,
          align leadership, and compound performance through purposeful systems. */}
          Whether you’re driving transformation across a portfolio or scaling a
          tech-led firm, Eternity helps you <span className="text-orange-500"> turn purpose into performance</span>, through clarity, rhythm, and AI-amplified intent.

        </motion.p>


        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
        >
          <a
            href="#segments"
            className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg shadow-lg font-semibold"
          >
            {/* Explore How We Help */}
            Explore Growth States
          </a>
          <a
            // href="#contact"
            onClick={() => setOpen({ visible: true, source: "clients-hero" })} // 25 Nov 2025
            className="bg-white/10 hover:bg-white/20 px-6 py-3 rounded-lg font-semibold cursor-pointer"
          >
            {/* Talk to Us */}
            Begin Your Discovery
          </a>
        </motion.div>
      </motion.div>
      {/* 25 Nov 2025 */}
      {open.visible && (
        <EtModalContactConversation
          open={open}
          onClose={() => setOpen({ visible: false, source: null })}
        />
      )}
    </section>
  );
};

export default EtClientsHero;